import React from 'react';
const ClaimProjectReportDetailsNavigation = () => {
  return /*#__PURE__*/React.createElement(React.Fragment, null);
};
export default ClaimProjectReportDetailsNavigation;